import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useTheme } from '@mui/material/styles';

export const GetStatusInfo = (status) => {
  const normalized = status?.toString().toUpperCase();
  const theme = useTheme();
  
  switch (normalized) {
    case 'SUCCESS':
    case 'PASS':
    case 'MET':
      return { icon: fas.faCircleCheck, color: theme.palette.success.main };
    case 'FAIL':
    case 'FAILED':
    case 'FAILURE':
      return { icon: fas.faCircleXmark, color: theme.palette.error.main };
    default:
      return { icon: fas.faMinus, color: theme.palette.text.secondary };
  }
};